/**
 * 文件说明:
 *
 * register auth layout
 *
 * ----------------------------------------
 * 创建用户: leo
 */

import {memo} from 'react'
import AuthLayout from './index'

function registerAuthLayout(PageComponent) {
    const AuthLayoutWarp = memo((props) => (
        <AuthLayout PageComponent={PageComponent} pageProps={props} />
    ))

    return AuthLayoutWarp
}

export default registerAuthLayout
